__turbopack_context__.v({
  "button": "BannerSlider-module-scss-module__iU05Mq__button",
  "content": "BannerSlider-module-scss-module__iU05Mq__content",
  "discount": "BannerSlider-module-scss-module__iU05Mq__discount",
  "img": "BannerSlider-module-scss-module__iU05Mq__img",
  "list": "BannerSlider-module-scss-module__iU05Mq__list",
  "listItem": "BannerSlider-module-scss-module__iU05Mq__listItem",
  "listTitle": "BannerSlider-module-scss-module__iU05Mq__listTitle",
  "price": "BannerSlider-module-scss-module__iU05Mq__price",
  "root": "BannerSlider-module-scss-module__iU05Mq__root",
  "slider": "BannerSlider-module-scss-module__iU05Mq__slider",
  "title": "BannerSlider-module-scss-module__iU05Mq__title",
  "titleCounter": "BannerSlider-module-scss-module__iU05Mq__titleCounter",
  "topText": "BannerSlider-module-scss-module__iU05Mq__topText",
  "topTextWrap": "BannerSlider-module-scss-module__iU05Mq__topTextWrap",
});
